import { apiClient } from '@app/api';
import { Box } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Spinner, Title } from '@ui/components';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useFragmentCtx } from '../../../context/fragment-ctx';
import { audiogramHelpers } from '../helpers';
import { VariantSelector } from '../preview/VariantSelector';
import { DownloadAudiogramBtn } from './DownloadAudiogramBtn';

export function AudiogramMediaPreview() {
  const fragment = useFragmentCtx();
  const completedVariants = audiogramHelpers.getCompletedVariants(fragment);
  const completedIds = completedVariants.map((v) => v.variant);

  const [variant, setVariant] = useState(completedIds[0]);

  const mediaUrlQuery = useQuery({
    queryKey: ['audiogram-media-url', fragment.id, variant],
    queryFn: () => apiClient.fragments.audiogramMediaUrl(fragment.id, variant),
    staleTime: 60 * 60 * 1000, // 1 hour in milliseconds
    enabled: !!variant,
  });

  return (
    <Box sx={{ width: '90%', height: '100%' }}>
      <Title>
        <FormattedMessage id="audiogram.audiogramGenerated" defaultMessage="Audiogram generado" />
      </Title>
      <Box display="flex" justifyContent="space-between">
        <VariantSelector variants={completedIds} value={variant} onChange={setVariant} />
        {!mediaUrlQuery.isLoading && (
          <Box>
            <DownloadAudiogramBtn url={mediaUrlQuery.data!} />
          </Box>
        )}
      </Box>
      {!mediaUrlQuery.isLoading && (
        <video
          src={mediaUrlQuery.data}
          controls
          style={{
            width: '100%',
            aspectRatio: variant.replace('x', '/'),
          }}
        />
      )}
      {mediaUrlQuery.isLoading && <Spinner />}
    </Box>
  );
}
